import { DataGrid, GridColumns } from "@mui/x-data-grid";
import React, { FunctionComponent, useEffect, useState } from "react";
import { AppStore } from "../../../../AppStore";
import { GridCard } from "../../../../components/gridManager/components/GridCard";
import { Diagnostic } from "../../../../services/diagnostic/models/Diagnostic";
import styles from "../styles/Components.css";

interface Props {}

const DiagnosticsList: FunctionComponent<Props> = (props) => {
  const [systems, systemsActions] = AppStore.systems.use();
  const [state, actions] = AppStore.diagnostics.use();
  const [diagnostics, setDiagnostics] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  const columns: GridColumns = [
    {
      field: "name",
      headerName: "Name",
      width: 160,
    },
    {
      field: "ssid",
      headerName: "Sub System",
      width: 160,
    },
    {
      field: "measurement",
      headerName: "Measurement",
      width: 130,
    },
    {
      field: "units",
      headerName: "Units",
      width: 130,
    },
    {
      field: "alerts",
      headerName: "Alerts",
      minWidth: 100,
      width: 400
    },
  ];

  const processDiagnostics = (diagnostics: Diagnostic[]) => {
    const processed: any[] = [];

    diagnostics.forEach((diagnostic, index) => {
      processed.push({
        name: diagnostic.name,
        ssid: diagnostic.ssid,
        measurement: diagnostic.measurement,
        units: diagnostic.units,
        alerts: diagnostic.alerts.map(a => a.value),
        id: index,
      });
    });

    return processed;
  };

  const handleDiagnostics = () => {
    if (systems.highlighted)
      actions
        .getCachedParentCollection(systems.highlighted)
        .then(processDiagnostics)
        .then(setDiagnostics)
        .then(() => setLoading(false))
        .catch(console.log);
  }

  // See ManifestViewer: depend on the id so a store refresh does not refetch.
  useEffect(() => {
    setLoading(true)
    handleDiagnostics()
  }, [systems.highlighted?.id]);

  useEffect(() => {
    if (!loading) handleDiagnostics();
  }, [state.collection]);

  return (
    <GridCard loading={loading} icon="./icons/diagnostic.png" title="Diagnostics">
      <div className={styles.listContainer}>
        <DataGrid
          rows={diagnostics}
          columns={columns}
          rowHeight={30}
          headerHeight={30}
          sx={{
            "& .MuiDataGrid-columnSeparator": {
              visibility: "hidden",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#e9e9e9",
            },
          }}
          hideFooter
        />
      </div>
    </GridCard>
  );
};

export default DiagnosticsList;
